import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/**
 * The outbreak campaigns a vaccination may be recorded against (KIN-1585).
 *
 * An empty list is the normal answer, not a failure: it means no outbreak is running,
 * which is the usual state of the world. Callers should stop offering Outbreak rather
 * than showing an error or an empty picker.
 */
export const useVaccineOutbreaks = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["vaccineOutbreaks", tenantVal],
    enabled: !!tenantVal,
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/vaccine-codes/outbreaks`
      );

      return response.data ?? [];
    },
    meta: { errorMessage: "Error fetching outbreak campaigns" },
  });
};
